import screens from "../../config/screensConfig";

export const addLocaleFontScalarsToDocument = (fontScaling: {
  mobileFontScaling: number;
  desktopFontScaling: number;
  lineHeightScaling: number;
}) => {
  const styleNode = document.createElement("style");

  styleNode.innerHTML = `
    :root {
      --locale-scaling-line-height: ${(
        fontScaling.lineHeightScaling * 0.01
      ).toFixed(2)};
      --locale-scaling-mobile: ${(fontScaling.mobileFontScaling * 0.01).toFixed(
        2
      )};
      @media (min-width: ${screens.dsk}) {
        --locale-scaling-mobile: 1;
        --locale-scaling-desktop: ${(
          fontScaling.desktopFontScaling * 0.01
        ).toFixed(2)};
      }
    }
  `;

  document.body.appendChild(styleNode);
};
